import React from 'react';

const UserContext = React.createContext({user: {}});

export { UserContext };